import { render, staticRenderFns } from "./omitText.vue?vue&type=template&id=52a61422&scoped=true"
import script from "./omitText.vue?vue&type=script&lang=js"
export * from "./omitText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a61422",
  null
  
)

export default component.exports